import { render, staticRenderFns } from "./MailKonfiguration.vue?vue&type=template&id=2a8bda5b&scoped=true&"
import script from "./MailKonfiguration.vue?vue&type=script&lang=js&"
export * from "./MailKonfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8bda5b",
  null
  
)

export default component.exports